import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-dashboard-guest-invited',
  templateUrl: './card-dashboard-guest-invited.component.html',
  styleUrls: ['./card-dashboard-guest-invited.component.scss']
})
export class CardDashboardGuestInvitedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
